import { ControllerParams, CreateControllerFn } from '@wix/yoshi-flow-editor';
import { setControllerFlowApi } from '../../services/controllerProps/controllerProps';
import { createParticipantFlow } from './utils/createParticipantFlow';

const createController: CreateControllerFn = async ({
  flowAPI,
}: ControllerParams) => {
  setControllerFlowApi(flowAPI);
  return {
    async pageReady() {
      return createParticipantFlow({
        flowAPI,
      });
    },
  };
};

export default createController;
